jQuery.keyboard.layouts["customnum"]={name:"custom-webco-num-layout",lang:["de"],normal:['{clear} {bksp}', '7 8 9', '4 5 6', '1 2 3', '0 {dec}', '{accept}']};